/* 平台创建的排班-时刻表 */
<template>
  <div id="schedulingPlatformTimeForm">

    <!-- 查看线路票价模态框 -->
    <el-dialog class="semoney" :visible.sync="dialogVisible3" width="40%">
      <div class="updatePrice">
        <span class="detail">{{ detailTitle }}</span>
        <span class="update" v-if="!showEdit" @click="handleEdit">{{
          lineInfo.railType == 2 && lineInfo.schedulingType == 3
          ? "修改价格"
          : "修改票价"
        }}</span>
      </div>
      <el-form ref="priceForm" :model="priceForm" style="margin: 0 auto">
        <el-table :data="priceForm.stationRailFee" border max-height="250" style="width: 100%">
          <el-table-column prop="startRailName" label="出发地">
          </el-table-column>
          <el-table-column prop="endRailName" label="目的地"> </el-table-column>
          <el-table-column prop="fee" width="180" :label="'票价'">
            <template slot-scope="scope">
              <el-form-item :prop="'stationRailFee.' + scope.$index + '.fee'" :rules="{
                required: true,
                message: '请设置票价',
                trigger: 'blur',
              }">
                <div v-if="showEdit" style="display: flex; padding-right: 2px">
                  <el-input v-model="scope.row.fee" maxlength="3"
                    oninput="value=value.replace(/[^\d]/g, '').replace(/^0/g,'')"
                    style="margin: 0; width: 150px; cursor: pointer">
                    <template slot="prepend">￥</template>
                    <template slot="append"></template>
                  </el-input>
                </div>
              </el-form-item>

              <span v-if="!showEdit">￥{{ scope.row.fee }}</span>
            </template>
          </el-table-column>
        </el-table>
      </el-form>
      <div class="submit">
        <el-button type="primary" @click="feeClick" v-if="showEdit">保存</el-button>
      </div>
    </el-dialog>

    <!-- 设置票价模态框 -->
    <el-dialog title="线路票价" :visible.sync="dialogVisible" width="360px" :close-on-click-modal="false">
      <el-input placeholder="这条路线的售票票价" maxlength="3" oninput="value=value.replace(/[^\d]/g, '').replace(/^0{1,}/g,'')"
        v-model="input2" prop="region">
        <template slot="append">元</template>
      </el-input>
      <div class="motoal">
        <el-button type="primary" size="mini" @click="feeSave">保存</el-button>
      </div>
    </el-dialog>

    <!-- 点击列表查看座位 -->
    <el-dialog title="座位详情" :visible.sync="dialogVisible2" width="400px" class="LookSeat">
      <div class="seat-top">
        <div class="seat-top-left">
          <span class="seat-top-span1"> </span>可选
        </div>
        <div class="seat-top-right">
          <span class="seat-top-span2"> </span>已购
        </div>
      </div>

      <div class="seat-content">
        <div class="driver">
          <div class="drivers"></div>
          司机
        </div>

        <div class="seat-content-center" :class="seats.length == 4
          ? 'passe1'
          : seats.length == 6
            ? 'passe2'
            : seats.length == 7
              ? 'passe3'
              : seats.length == 8
                ? 'passe4'
                : ''
          " v-for="(item, index) in seats" :key="index">
          <div v-if="item.isSoldTicket == 1" class="content-center">
            <img style="width: 100%; height: 100%" src="../../../assets/img/kexuan1.png" alt="" />
            <span class="seat-details">{{ item.seatNo }}</span>
          </div>
          <div v-if="item.isSoldTicket == 2" class="content-center">
            <img style="width: 100%; height: 100%" src="../../../assets/img/yixuan1.png" alt="" />
            <span class="seat-details1">{{ item.seatNo }}</span>
          </div>
          <p>¥{{ item.fee }}</p>
        </div>
      </div>
      <div class="motoal">
        <el-button type="primary" @click="dialogVisible2 = false">关闭</el-button>
      </div>
    </el-dialog>

    <!-- 编辑班次 -->
    <el-dialog title="编辑班次" :visible.sync="editShiftDialogVisible" width="465px" :close-on-click-modal="false">
      <el-form class="editShiftForm" :model="editShiftForm" ref="editShiftForm" label-width="100px" label-position="left">
        <el-form-item label="接人/检票" prop="startTime"
          :rules="[{ required: true, validator: validateStart, trigger: 'change' }]">
          <el-time-picker v-model="editShiftForm.startTime" format="HH:mm" value-format="HH:mm"
            style="width:260px"></el-time-picker>
        </el-form-item>
        <el-form-item label="预计发车" prop="endTime"
          :rules="[{ required: true, validator: validateEnd, trigger: 'change' }]">
          <el-time-picker v-model="editShiftForm.endTime" format="HH:mm" value-format="HH:mm"
            style="width:260px"></el-time-picker>
        </el-form-item>
        <el-form-item label="票数限制" prop="ticketNumType" :rules="{ required: true, message: '请选择票数限制', trigger: 'blur', }"
          v-if="lineInfo.schedulingType == 2">
          <el-radio-group v-model="editShiftForm.ticketNumType" style="display:flex;align-items:center;">
            <el-radio :label="1">不限购</el-radio>
            <el-radio :label="2">限购</el-radio>
            <el-form-item style="margin-bottom:0px" prop="ticketNum" :rules="[
              {
                required: Boolean(editShiftForm.ticketNumType == 2),
                message: '请输入限购数量',
                trigger: 'blur',
              },
              {
                pattern: /^[1-9]\d{0,2}$/,
                message: '请输入数字',
              },
            ]">
              <el-input style="width:120px" maxlength="3" v-model="editShiftForm.ticketNum"
                :disabled="editShiftForm.ticketNumType == 1"
                oninput="value=value.replace(/[^\d]/g, '').replace(/^0/g, '').replace(/^[1-9][0-9]{3,}/g,'999')">
                <template slot="append">张</template>
              </el-input>
            </el-form-item>
          </el-radio-group>
        </el-form-item>
        <div style="text-align:center;margin-top:30px">
          <el-button type="primary" style="width:150px;" @click="editShiftSave">保存</el-button>
        </div>
      </el-form>
    </el-dialog>

    <!-- 编辑值班车辆班次 -->
    <schedulingVehicle @confirm="vehicleConfirm" :visible.sync="schedulingVehicleShow" :line="lineInfo"
      :scheduling="editShiftForm" :drivers.sync="editShiftDrivers" :multiple="lineInfo.schedulingType === 2"
      :lineOId="lineInfo.organizationId" />

    <div class="schedulingPlatformTimeForm-head">
      <div class="schedulingPlatformTimeForm-head-left">
        <img class="icon-line" src="../../../assets/img/line.png" alt="" />
        <span style="font-weight: 600" v-if="schedulingJson">{{ getWeek(selectSchedulingTime) }} {{ selectSchedulingTime |
          filterTime("MM-DD") }}</span>
        <span style="margin:0 10px">|</span>
        <span style="font-weight: 600">{{ lineInfo.startStationName }} - {{ lineInfo.endStationName }}</span>

        <div style="display: flex; height: 28px; margin: 0 30px">
          <span v-if="lineInfo.schedulingType == 1 ||
            lineInfo.schedulingType == 3 ||
            lineInfo.schedulingType == 2
            ">{{ lineInfo.schedulingType | filterConst("SCHELINGTYPE") }}
          </span>
        </div>

        <div v-if="lineInfo.railType !== 2 &&
          (lineInfo.schedulingType == 1 || lineInfo.schedulingType == 2)
          ">
          票价:<span style="color: rgb(255, 153, 0)">{{
            lineInfo.fee == null ? "待设置" : "¥" + lineInfo.fee
          }}</span>
        </div>
      </div>
      <div>
        <el-button type="primary" style="margin-right: 10px;" @click="createdShift">创建班次</el-button>
        <el-button type="primary" v-if="lineInfo.railType == 2" @click="showLine">查看票价</el-button>
      </div>
    </div>

    <!-- 班次列表 -->
    <div class="schedulingPlatformTimeForm-body">
      <div class="scheduling-form-date">
        <div class="left">
          <custom-across-roll ref="customAcrossRoll">
            <div class="date" :class="dateActiveIndex == i ? 'active' : ''" @click="dateClick(scheduling, i)"
              @mouseover="dateHover('over', i)" @mouseout="dateHover('out', i)" v-for="(scheduling, i) in schedulingJson"
              :key="i">
              <span class="date-text">{{ getWeek(scheduling.schedulingTime) }}
                {{ scheduling.schedulingTime | filterTime("MM-DD") }}</span>
              <span class="date-close" :class="scheduling.removeIconShow == 1 ? 'remove' : ''"
                @click.stop="removeSchedulingTime(scheduling, i)">×</span>
            </div>
          </custom-across-roll>
        </div>
      </div>

      <div style="display: flex; align-items: center; margin: 20px 0">
        <strong style="margin-right: 20px">状态：</strong>
        <el-radio-group v-model="status" @change="statusChange" style="margin-right: 50px">
          <el-radio :label="1">全部</el-radio>
          <el-radio :label="2">停止售票</el-radio>
          <el-radio :label="3">售票中</el-radio>
        </el-radio-group>

        <el-checkbox v-model="checked" @change="statusChange">只看有余票</el-checkbox>
      </div>

      <!-- <div class="util-remark" v-if="type !== 'view'">
        注意：只有无人购票的班次，才能被编辑和删除
      </div> -->

      <div class="scheduling-form-table">
        <el-table :data="shiftFilterTable" border style="width: 100%">
          <el-table-column prop="date" label="状态">
            <template slot-scope="{row}">
              <span v-if="row.status == 1 && row.isEnabled == 1">售票中</span>
              <span v-if="row.status == 2 || row.isEnabled == 2">停止售票</span>
            </template>
          </el-table-column>
          <el-table-column prop="startTime"
            :label="`开始${[1, 2].includes(lineInfo.lineType) ? '检票' : '接人'}`"></el-table-column>
          <el-table-column prop="endTime" label="预计发车"></el-table-column>
          <el-table-column prop="licenseNo" label="值班车辆" v-if="[1, 3].includes(lineInfo.schedulingType)" min-width="170">
            <template slot-scope="{row}">
              <div v-if="row.schedulingVehicleJson">
                <span
                  :class="{ link: lineInfo.schedulingType == 3 }"
                  :style="getPlateStyle(row.schedulingVehicleJson[0].licenseNo)"
                  @click="lookSeat(row)"
                >{{ formatPlateNumber(row.schedulingVehicleJson[0].licenseNo) }}</span>
                <el-tag style="margin: 0 10px">{{ row.schedulingVehicleJson[0].vehicleSeat }}座</el-tag>
                <span style="margin-left:5px">{{ row.schedulingVehicleJson[0].driverName }}</span>
              </div>
              <div v-else>-</div>
            </template>
          </el-table-column>
          <el-table-column prop="address" label="票数限制" v-if="![1, 3].includes(lineInfo.schedulingType)">
            <template slot-scope="{row}">
              {{ row.ticketNumType == 1 ? "不限购" : "限购：" + row.ticketNum + "张" }}
            </template>
          </el-table-column>
          <el-table-column prop="ticketNum" label="可购票" v-if="[1, 3].includes(lineInfo.schedulingType)">
            <template slot-scope="{row}">
              <span>{{ row.ticketNum || "-" }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="soldTickets" label="已购票">
            <template slot-scope="{row}">
              <span>{{ row.ticketNum ? row.soldTickets : "-" }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="remainingTickets" label="余票">
            <template slot-scope="{row}">
              {{ row.ticketNum ?
                (row.remainingTickets ? row.remainingTickets : row.ticketNumType == 1 ? "-" : row.compile ? "-" : 0)
                : "-" }}
            </template>
          </el-table-column>
          <el-table-column prop="isEnabled" label="是否启用">
            <template slot-scope="{row}">
              <el-switch v-model="row.isEnabled" :active-value="1" :inactive-value="2"
                @change="switchClick($event, row)"></el-switch>
            </template>
          </el-table-column>
          <el-table-column prop="address" label="操作" width="180">
            <template slot-scope="{$index,row}">
              <el-button v-if="Number(row.soldTickets) <= 0"
                @click="editShift({ ...row, beforeTime: $index == 0 ? null : form.shiftActive[$index - 1].startTime, afterTime: $index == form.shiftActive.length - 1 ? null : form.shiftActive[$index + 1].startTime })"
                type="text">编辑班次</el-button>
              <el-button v-if="([1, 3].includes(lineInfo.schedulingType) && Number(row.soldTickets) <= 0)" type="text"
                @click="editVehicle(row, $index)">值班车辆</el-button>
              <el-button v-if="Number(row.soldTickets) <= 0" @click="removeFn(row, $index)" type="text">删除</el-button>
              <div v-if="Number(row.soldTickets) > 0" style="color:#999;line-height:28px">有乘客购票无法编辑</div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "schedulingPlatformTimeForm",
  components: {
    customAcrossRoll: () => import("../../../components/custom-across-roll.vue"),
    schedulingVehicle: () => import("./schedulingVehicle.vue"),
  },
  props: ['lineId', 'type'],
  data() {
    return {
      detailTitle: "线路票价",
      buyBool: false,
      showEdit: false, //显示编辑框
      //票价
      input2: "",
      lastListArr: [],
      //模态框
      dialogVisible: false,
      dialogVisible2: false,
      dialogVisible3: false,
      dialogIndex: [],
      dialogDrivers: [],
      dialogScheduling: {},
      schedulingVehicleShow: false,
      today: new Date().setHours(23, 59, 59, 0) / 1000,
      // 表单对象
      form: {
        // 当前选中的
        shiftActive: [],
      },
      // 筛选后的班次表格
      shiftFilterTable: [],
      // 线路详情信息
      lineInfo: {},
      //线路详情数据
      priceForm: {
        stationRailFee: [],
      },

      // 加载中
      loading: false,

      schedulingJson: [],
      // 选中的日期索引
      dateActiveIndex: 0,
      //点击查看座位数据
      seats: [],

      status: 1,
      checked: false,
      lineOId: "",


      editShiftDialogVisible: false,
      editShiftForm: {},

      // 当前选择的排班日期
      selectSchedulingTime: null,

      // 值班司机
      editShiftDrivers: [],
    };
  },
  watch: {
    "form.shiftActive"(item) {
      this.statusChange();
      this.selectSchedulingTime = this.schedulingJson[this.dateActiveIndex].schedulingTime;
      this.$emit("schedulingTimeUpdate", this.selectSchedulingTime);
    },
    dialogVisible3(val) {
      if (!val) {
        this.$refs.priceForm.resetFields();
      }
    },
  },

  created() {
  },
  mounted() {
    this.getInfo();
    // 页面视口发生变化时调用子组件判断是否需要显示左右箭头
    // this.$nextTick(() => {
    //   if (this.$refs.customAcrossRoll) {
    //     this.$refs.customAcrossRoll.isShow();
    //   }
    // });
  },
  methods: {
    validateStart(rule, value, callback) {
      let item = this.editShiftForm.startTime;
      let beforeTime = this.editShiftForm.beforeTime;
      let afterTime = this.editShiftForm.afterTime;
      if (!value) {
        callback(new Error("“接人/检票时间”不能为空"));
      } else if (beforeTime && item < beforeTime) {
        callback(new Error("请设置大于等于上个班次的“接人/检票时间”"));
      } else if (afterTime && item > afterTime) {
        callback(new Error("请设置小于等于下个班次的“接人/检票时间”"));
      } else {
        callback();
      }
    },
    /* 验证器-编辑发车时间 */
    validateEnd(rule, value, callback) {
      let item = this.editShiftForm.endTime;
      let startItem = this.editShiftForm.startTime;
      if (!value) {
        callback(new Error("发车时间不能为空"));
      } else if (item < startItem) {
        callback(new Error("不能小于“接人/检票时间”"));
      } else {
        callback();
      }
    },

    // 跳转创建班次页面
    createdShift() {
      this.$router.push({ path: 'schedulingSettingEdit', query: { lineId: this.lineId, dateActiveIndex: this.dateActiveIndex } })
    },

    // 查看路线详情
    async showLine() {
      this.dialogVisible3 = true;
      this.showEdit = false;
      let url = "/api/v1/manage/line/stationRail/" + this.lineId;
      let data = await this.$axios.get(url);
      if (data && data.code == 1) {
        this.priceForm.stationRailFee = data.data;
        this.getTickets();
      }
    },

    // 是否购票
    async getTickets() {
      this.dialogVisible3 = true;
      this.showEdit = false;
      let url = "/api/v1/manage/line/queryIsSoldTicketsByLineId/" + this.lineId;
      let data = await this.$axios.get(url);
      if (data && data.code == 1) {
        this.buyBool = data.data;
        // this.priceForm.stationRailFee = data.data;
      }
    },

    // 点击查看显示座位
    async lookSeat(row) {
      this.seats = [];
      if (this.lineInfo.schedulingType == 3) {
        this.dialogVisible2 = true;
        let url = "/api/v1/manage/line/vehicle/seatNoAndFee";
        let params = {
          schedulingId: row.id,
          vehicleId: row.schedulingVehicleJson[0].vehicleId,
        };
        let data = await this.$axios.get(url, params);
        if (data && data.code == 1) {
          data.data.forEach((row) => {
            row.seatNo = row.seatNo.substring(0, 1);
          });
          this.seats = data.data;
        }
      }
    },

    /* 班次状态开关 */
    switchClick(isEnabled, row) {
      let params = {
        isEnabled: row.isEnabled,
        schedulingId: row.id,
      };
      if (isEnabled == 1) {
        this.$confirm("确认启用该班次吗?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "success",
        })
          .then(() => {
            this.postSwitch(params, isEnabled, row);
          })
          .catch(() => {
            row.isEnabled = 2;
          });
      } else {
        this.$confirm("停止该班次后，乘客将无法购票，确认这样做吗?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.postSwitch(params, isEnabled, row);
          })
          .catch(() => {
            row.isEnabled = 1;
          });
      }
    },

    postSwitch(params, isEnabled, row) {
      let url = "/api/v1/manage/line/scheduling/isEnabled";
      this.$axios
        .post(url, params)
        .then((data) => {
          if (data && data.code == 1) {
            if (isEnabled == 1) {
              this.$message({
                type: "success",
                message: "启用成功",
              });
            } else {
              this.$message({
                type: "success",
                message: "已禁用!",
              });
            }
            this.getInfo();
          } else {
            row.isEnabled = row.isEnabled == 1 ? 2 : 1;
          }
        })
        .catch((err) => {
          row.isEnabled = row.isEnabled == 1 ? 2 : 1;
        });
    },

    // 修改排班模式
    async postSchedulingType(schedulingType) {
      let url = "/api/v1/manage/line/schedulingType";
      let params = {
        lineId: this.lineId,
        schedulingType,
      };
      let data = await this.$axios.post(url, params);
      if (data && data.code == 1) {
        this.getInfo();
      }
    },

    getWeek(timestamp) {
      let date = new Date(timestamp * 1000);
      var week;
      if (date.getDay() == 0) week = "周日";
      if (date.getDay() == 1) week = "周一";
      if (date.getDay() == 2) week = "周二";
      if (date.getDay() == 3) week = "周三";
      if (date.getDay() == 4) week = "周四";
      if (date.getDay() == 5) week = "周五";
      if (date.getDay() == 6) week = "周六";
      return week;
    },

    //删除班次
    removeFn(row) {
      this.$confirm(`确定删除班次吗？`, "提示").then(async () => {
        let url = "/api/v1/manage/line/scheduling/" + row.id;
        let data = await this.$axios.delete(url);
        if (data && data.code == 1) {
          this.$message.success('班次已删除');
          this.getInfo();
        }
      })
    },

    /* 编辑班次 */
    editShift(row) {
      this.editShiftDialogVisible = true;
      this.editShiftForm = { ...row };
    },

    /* 编辑班次-保存 */
    editShiftSave() {
      this.$refs.editShiftForm.validate(async (valid) => {
        if (valid) {
          let url = "/api/v1/manage/line/scheduling/edit";
          let { startTime, endTime, ticketNumType, ticketNum, id: schedulingId } = { ...this.editShiftForm }
          let data = await this.$axios.post(url, { startTime, endTime, ticketNumType, ticketNum, schedulingId });
          if (data && data.code == 1) {
            this.$message.success('已保存');
            this.editShiftDialogVisible = false;
            this.getInfo();
          }
        }
      });
    },

    /* 日期鼠标悬浮 */
    async dateHover(type, i) {
      let obj = new Object(this.schedulingJson[i]);
      if (type == "over" && obj.removeIconShow) {
        this.schedulingJson[i].removeIconShow = 1;
      }
      if (type == "out" && obj.removeIconShow) {
        this.schedulingJson[i].removeIconShow = 2;
      }
    },

    /* 点击日期按钮 */
    async dateClick(item, i) {
      this.dateActiveIndex = i;
      this.form.shiftActive = item.shift || [];
    },

    /* 删除某个排班日期 */
    async removeSchedulingTime(scheduling, i) {
      let date = this.$utils.timeFn(this.schedulingJson[i].schedulingTime, "MM-DD");
      if (scheduling.soldTicketsSum > 0) {
        this.$alert(`该日期(${date})下已有乘客购票，无法被删除！`, "提示");
        return;
      }
      this.$confirm(`确认删除该日期(${date})下全部班次吗？`, "删除提示").then(async () => {
        let url = "/api/v1/manage/line/scheduling/batch/" + this.lineId;
        let data = await this.$axios.delete(url, { schedulingTime: scheduling.schedulingTime });
        if (data && data.code == 1) {
          this.$message.success("已删除");
          if (i == this.dateActiveIndex) {
            this.dateActiveIndex = 0;
          }
          this.getInfo()
        }
      });
    },



    async queryIsSoldTickets(schedulingId) {
      if (!schedulingId) {
        return false;
      } else {
        let url = "/api/v1/manage/line/queryIsSoldTickets/" + schedulingId;
        let data = await this.$axios.get(url);
        if (data && data.code == 1) {
          return data.data;
        } else {
          return false;
        }
      }
    },

    /* 编辑值班车辆 */
    async editVehicle(row, index) {
      let status = await this.queryIsSoldTickets(row.id);
      if (status) {
        this.$message.warning("该班次已有乘客购票，无法编辑车辆");
        this.refresh(this.lineInfo.schedulingType);
      } else {
        this.schedulingVehicleShow = true;
        this.editShiftForm = row;
        this.editShiftDrivers = row.schedulingVehicleJson || [];
      }
    },

    /* 确定值班车辆 */
    async vehicleConfirm(result) {
      // 更新行票数
      if ([1, 3].includes(this.lineInfo.schedulingType)) {
        let ticketNum = result.reduce((a, b) => a + (b.vehicleSeat - 1), 0);
        this.editShiftForm.ticketNum = ticketNum;
        this.editShiftForm.soldTickets = 0;
        this.editShiftForm.remainingTickets = ticketNum;
      }


      // 不是选座模式就把座位价格字段删除
      if (this.lineInfo.schedulingType != 3) {
        delete result[0].vehicleSeatAndFeeVos
      } else {
        if (result[0].vehicleSeatAndFeeVos) {
          result[0].vehicleSeatAndFeeVos = result[0].vehicleSeatAndFeeVos.map(
            (item) => {
              item.id = null;
              return item;
            }
          );
        }
        result[0].vehicleSeatAndFeeVos = JSON.stringify(result[0].vehicleSeatAndFeeVos)
      }
      let url = "/api/v1/manage/line/scheduling/vehicle";
      let params = {
        schedulingId: this.editShiftForm.id,
        ...result[0],
      };
      let data = await this.$axios.post(url, params);
      if (data && data.code == 1) {
        this.$message.success(`车辆已${this.editShiftForm.schedulingVehicleJson ? '修改' : '添加'}`);
        if (this.lineInfo.schedulingType == 3) {
          result[0].vehicleSeatAndFeeVos = JSON.parse(result[0].vehicleSeatAndFeeVos)
        }
        this.editShiftForm.schedulingVehicleJson = [{ ...result[0] }];
      }
    },

    refresh(schedulingType) {
      this.dateActiveIndex = 0;
      this.schedulingJson = [];
      this.form = {
        shiftActive: []
      };
      this.lineInfo.fee = null;
      this.lineInfo = {
        schedulingType,
      };

      this.getInfo();
    },

    /* 状态筛选 */
    statusChange() {
      if (this.form.shiftActive) {
        this.form.shiftActive.map((item) => {
          item.show = false;
          if (this.status == 1) {
            item.show = true;
          } else if (this.status == 2) {
            item.show = item.status == 2 || item.isEnabled == 2;
          } else if (this.status == 3) {
            item.show = item.status == 1 && item.isEnabled == 1;
          }
          if (this.checked && item.show) {
            item.show = item.remainingTickets > 0 || item.ticketNumType == 1;
          }
        });
        this.shiftFilterTable = this.form.shiftActive.filter(val => val.show)
      } else {
        this.shiftFilterTable = [];
      }
    },

    /* 获取平台排班信息 dateActiveIndex 指定日期下标 */
    async getInfo() {
      let url = "/api/v1/manage/line/scheduling/" + this.lineId;
      let res = await this.$axios.get(url, { channel: 1 });
      if (res?.code == 1) {
        res = res.data;
        this.lineOId = res?.line?.organizationId;
        this.schedulingJson = [];
        if (res?.line?.schedulingType) {
          let currentList = [];
          if (res.scheduling?.length > 0) {
            let minTime = new Date().setHours(0, 0, 0, 0) / 1000; // 当天0点
            let lastTime = res.scheduling[res.scheduling.length - 1].schedulingTime;
            if (lastTime - minTime && (lastTime - minTime) / 86400 + 1 != res.scheduling.length) {
              // 日期组缺少日期手动补偿，正常不会存在此情况
              for (let i = 0; i < (lastTime - minTime) / 86400 + 1; i++) {

                let item = res.scheduling.find((item) => item.schedulingTime == minTime + 86400 * i);
                if (item) {
                  let soldTicketsSum = 0;
                  if (item.shift && item.shift.length > 0) {
                    soldTicketsSum = item.shift.reduce(function (prev, cur) {
                      return Number(cur.soldTickets) + prev;
                    }, 0);
                  }
                  item.removeIconShow = 2;
                  item.soldTicketsSum = soldTicketsSum;
                  currentList.push(item);
                } else {
                  currentList.push({
                    schedulingTime: minTime + 86400 * i,
                    shift: [],
                    removeIconShow: 2, // 控制日期是否可被可被移除, 1-可以移除，显示，2-可以移除，不显示，其他-不可移除
                    soldTicketsSum: 0
                  });
                }
              }
            } else {
              currentList = res.scheduling.map((item) => {
                let soldTicketsSum = 0;
                if (item.shift && item.shift.length > 0) {
                  soldTicketsSum = item.shift.reduce(function (prev, cur) {
                    return cur.soldTickets + prev;
                  }, 0);
                }
                item.removeIconShow = 2;
                item.soldTicketsSum = soldTicketsSum;
                return item;
              });
            }


            let times1 = res.lineVehicleList ? res.lineVehicleList.map((item) => item.schedulingTime) : [];
            let times2 = currentList ? currentList.map((item) => item.schedulingTime) : [];
            let times = Array.from(new Set([...times1, ...times2]));
            currentList.forEach((item) => {
              let target = times.find((time) => time == item.schedulingTime);
              // 判断是不是已有的数据
              if (target) {
                // 班次信息数据初始化
                this.schedulingJson.push(item);
              }
            });
            this.form.shiftActive = currentList && currentList.length > 0 && currentList[this.dateActiveIndex].shift ? currentList[this.dateActiveIndex].shift : [];

          } else {
            // 班次为空情况下
            let tomorrow = new Date().setHours(0, 0, 0, 0) / 1000; // 当天0点

            this.schedulingJson.push({
              schedulingTime: tomorrow,
              shift: [],
            });

            this.form.shiftActive = [];
          }
        }
        this.lineInfo = res.line || {};
        this.$emit("infoUpdate", this.lineInfo);
      }
    },

    // 设置班车票价
    async feeSave() {
      if (this.input2 == 0) {
        this.$message({
          message: "票价不能为0元!",
          type: "error",
        });
        return false;
      }

      this.dialogVisible = false;
      let params = {
        lineId: this.lineId,
        fee: this.input2,
      };
      let url = "/api/v1/manage/line/saveLineFee";
      let data = await this.$axios.post(url, params);
      if (data && data.code == 1) {
        this.lineInfo.fee = this.input2;
        this.input2 = "";
      }
    },

    handleEdit() {
      if (this.buyBool) {
        this.$message({
          message: "已有乘客购票，无法修改票价",
          type: "warning",
        });
      } else {
        this.detailTitle = "修改票价";
        this.showEdit = true;
      }
    },

    //修改线路价格
    async feeClick() {
      this.$refs.priceForm.validate((valid) => {
        if (valid) {
          let params = {};
          params.stationRailFee = JSON.stringify(this.priceForm.stationRailFee);
          this.updateRailFee(params);
        }
      });
    },

    //修改线路价格
    async updateRailFee(params) {
      let url = "/api/v1/manage/line/stationRail/updateRailFee";
      let data = await this.$axios.post(url, params);
      if (data && data.code == 1) {
        this.$message.success("编辑成功！");
      }
      this.dialogVisible3 = false;
      this.detailTitle = "线路票价";
    }
  },
};
</script>

<style lang="less" scoped>
#schedulingPlatformTimeForm {
  .schedulingPlatformTimeForm-head {
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    &-left {
      display: flex;
      align-items: center;
      font-size: 20px;
      font-weight: 500;
      line-height: 28px;
      color: #333333;

      .icon-line {
        width: 20px;
        margin-right: 8px;
        height: auto;
      }

      .icon-type {
        font-size: 16px;
        margin-left: 22px;
        font-weight: 500;
        line-height: 30px;
        border-radius: 4px;
        color: #409efc;
        padding: 2px 8px;
        background: rgba(64, 158, 252, 0.1);
      }

      .line-money {
        display: flex;
        align-items: center;
        background: #ffffff;
        box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.05);
        border-radius: 6px;
        height: 36px;
        padding: 0 12px;
        margin-left: 22px;

        img {
          width: 20px;
          height: auto;
          margin-right: 4px;
          font-size: 20px;
          font-weight: 500;
          color: #333333;
        }
      }
    }
  }

  .schedulingPlatformTimeForm-body {
    display: flex;
    flex-flow: column;

    .el-input {
      min-width: 100px;
      width: 100%;
    }

    .ticket-num {
      width: 110px;

      /deep/ input {
        padding: 0 10px;
        text-align: center;
      }
    }
  }

  .scheduling-form-date {
    width: 100%;
    display: flex;
    align-items: center;
    margin: 12px 0;

    .left {
      width: 100%;
    }
  }

  .scheduling-form-table {
    margin-top: 12px;
    /*height: 100%;*/
    /*overflow: auto;*/
    width: 100%;

    .el-input__inner {
      width: 100%;
    }

    .el-radio-group {
      display: flex;
      align-items: center;

      .el-input-group__append {
        padding: 0 6px;
      }
    }

    .table {
      width: 100%;
      border-collapse: collapse;
      border: 1px solid #ebeef5 !important;
      outline: none;

      th,
      td {
        height: 38px;
        font-size: 14px;
        font-weight: 400;
        color: rgba(34, 34, 34, 1);
        width: 130px;
        border-color: #ebeef5 !important;
        box-sizing: border-box;
        padding: 0 12px;
      }

      th {
        background-color: #fafafa;
        text-align: left;
      }

      .gray td {
        color: #999 !important;
      }
    }

    .table_scheduling {
      .el-button {
        margin-left: 0;
        margin-right: 10px;
      }

      .th1,
      .th5,
      .th7,
      .th8 {
        width: 80px;
      }

      .th6 {
        width: 120px;
      }

      .th4 {
        width: 160px;
        padding: 12px;
        line-height: 20px;
      }
    }

    .el-form-item__error {
      z-index: 10;
      white-space: nowrap;
    }
  }

  .editShiftForm {
    .el-form-item {
      margin-bottom: 18px;
    }
  }

  .el-form-item {
    margin-bottom: 0;
  }

  .el-radio {
    position: relative;
    top: 1.5px;
  }

  .motoal {
    text-align: center;
    margin-top: 20px;
  }

  // 禁用input的number箭头
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
  }

  input[type="number"] {
    -moz-appearance: textfield;
  }

  /deep/ .el-dialog {
    .el-dialog__header {
      padding-bottom: 0;
    }

    .el-dialog__body {
      padding-top: 20px;
    }

    .el-input-group__prepend {
      padding: 0 10px;
    }

    .el-input-group .el-input__inner {
      border-radius: 0px 4px 4px 0 !important;
      border-right: 1px solid #dcdfe6 !important;
    }
  }
}

.LookSeat {
  .seats-price {
    padding: 0 0 0 160px;
    box-sizing: border-box;
  }

  .seat-top {
    display: flex;
    justify-content: center;

    >div {
      display: flex;
      align-items: center;
    }

    .seat-top-left {
      margin-right: 40px;
    }

    .seat-top-right {
      margin-left: 20px;
    }

    .seat-top-span1 {
      display: inline-block;
      width: 18px;
      height: 18px;
      margin-right: 6px;
      background: url("../../../assets/img/kexuan.png") no-repeat;
      background-size: 100% 100%;
    }

    .seat-top-span2 {
      display: inline-block;
      width: 18px;
      height: 18px;
      margin-right: 6px;
      background: url("../../../assets/img/yixuan.png") no-repeat;
      background-size: 100% 100%;
    }
  }

  .seat-content {
    display: flex;
    flex-wrap: wrap;
    margin-top: 20px;

    .content-center {
      width: 40px;
      height: 40px;
      text-align: center;
      line-height: 40px;
      color: #fff;
      font-weight: bold;
      position: relative;

      .seat-details {
        color: #409efc;
        position: absolute;
        top: -4px;
        left: 15px;
      }

      .seat-details1 {
        color: #fff;
        position: absolute;
        top: -4px;
        left: 15px;
      }
    }

    .driver {
      text-align: center;
      font-weight: bold;
      margin-left: 100px;
      margin-top: 10px;
    }

    .drivers {
      margin-bottom: 8px;
      width: 40px;
      height: 40px;
      text-align: center;
      line-height: 40px;
      background: url("../../../assets/img/siji.png");
      font-weight: bold;
    }
  }

  .passe1 {
    margin-top: 10px;

    >p {
      margin-top: 8px;
      text-align: center;
      font-size: 16px;
      font-weight: 600;
      color: #333333;
    }

    &:nth-child(2) {
      margin-left: 60px;
      margin-right: 60px;
    }

    &:nth-child(3) {
      margin-left: 70px;
    }

    &:nth-child(4) {
      margin-left: 50px;
    }

    &:nth-child(5) {
      margin-left: 40px;
    }
  }

  .passe2 {
    margin-top: 10px;

    >p {
      margin-top: 8px;
      text-align: center;
      font-size: 16px;
      font-weight: 600;
      color: #333333;
    }

    &:nth-child(2) {
      margin-left: 70px;
    }

    &:nth-child(3) {
      margin-left: 100px;
    }

    &:nth-child(4) {
      margin-left: 70px;
      margin-right: 20px;
    }

    &:nth-child(5) {
      margin-left: 70px;
    }

    &:nth-child(6) {
      margin-left: 45px;
    }

    &:nth-child(7) {
      margin-left: 45px;
    }
  }

  .passe3 {
    margin-top: 10px;

    >p {
      margin-top: 8px;
      text-align: center;
      font-size: 16px;
      font-weight: 600;
      color: #333333;
    }

    &:nth-child(2) {
      margin-left: 70px;
      margin-right: 70px;
    }

    &:nth-child(3) {
      margin-left: 70px;
    }

    &:nth-child(4) {
      margin-left: 45px;
    }

    &:nth-child(5) {
      margin-left: 45px;
    }

    &:nth-child(6) {
      margin-left: 70px;
    }

    &:nth-child(7) {
      margin-left: 45px;
    }

    &:nth-child(8) {
      margin-left: 45px;
    }
  }

  .passe4 {
    margin-top: 10px;

    >p {
      margin-top: 8px;
      text-align: center;
      font-size: 16px;
      font-weight: 600;
      color: #333333;
    }

    &:nth-child(2) {
      margin-left: 70px;
      margin-right: 0px;
    }

    &:nth-child(3) {
      margin-left: 100px;
    }

    &:nth-child(4) {
      margin-left: 70px;
    }

    &:nth-child(5) {
      margin-left: 100px;
    }

    &:nth-child(6) {
      margin-left: 70px;
    }

    &:nth-child(7) {
      margin-left: 78px;
    }

    &:nth-child(8) {
      margin-left: 40px;
    }

    &:nth-child(9) {
      margin-left: 40px;
    }
  }
}

.updatePrice {
  margin-top: -20px;
  margin-bottom: 20px;

  .detail {
    font-size: 17px;
    font-weight: bolder;
    padding-right: 10px;
  }

  .update {
    cursor: pointer;
    color: #0288ff;
  }
}

.submit {
  margin-top: 15px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  button {
    width: 100px;
    padding: 7px 15px;
  }
}
</style>
